
@file:Suppress("unused")
package tk.mallumo.compose.navigation


import tk.mallumo.compose.navigation.*
import androidx.compose.animation.Crossfade
import androidx.compose.animation.core.FiniteAnimationSpec
import androidx.compose.animation.core.tween
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.runtime.*
import tk.mallumo.compose.navigation.ImplNoteUtils.navNode
import tk.mallumo.compose.navigation.viewmodel.ViewModelFactory


private const val navChildKey = "child"

@ExtNavMarker
@Composable
fun NavigationRoot(
    startupNode: Node,
    startupArgs: ArgumentsNavigation? = null,
    appQuitEnabled: Boolean = true,
    animation: FiniteAnimationSpec<Float> = tween()
) {
    
    setupViewModelFactory()

    val navigation = Navigation.rememberNavigationComposite(
        startupNode = startupNode, 
        startupArgs = startupArgs,
        graph = Graph.Companion.ROOT,
        appQuitEnabled = appQuitEnabled)
     
    val currentNode = navigation.currentNode.collectAsState()

    Crossfade(targetState = currentNode.value, animationSpec = animation) {
        Surface(color = MaterialTheme.colorScheme.background) {
            CompositionLocalProvider(LocalNavigation provides navigation) {
                navNode(node = it)
            }
        }
    }
}

@Composable
private fun setupViewModelFactory() {
	ViewModelFactory.register(one.devsbox.www.ui.login.LoginVM::class){one.devsbox.www.ui.login.LoginVM()}
	ViewModelFactory.register(one.devsbox.www.ui.resources.detail.ResourceVM::class){one.devsbox.www.ui.resources.detail.ResourceVM()}
	ViewModelFactory.register(one.devsbox.www.ui.resources.ListingResourcesVM::class){one.devsbox.www.ui.resources.ListingResourcesVM()}
	ViewModelFactory.register(one.devsbox.www.ui.users.detail.UserDVM::class){one.devsbox.www.ui.users.detail.UserDVM()}
	ViewModelFactory.register(one.devsbox.www.ui.users.ListingUsersVM::class){one.devsbox.www.ui.users.ListingUsersVM()}
	ViewModelFactory.register(one.devsbox.www.ui.users.activity.UsersActivityVM::class){one.devsbox.www.ui.users.activity.UsersActivityVM()}
	ViewModelFactory.register(one.devsbox.www.ui.users.edit.UserEVM::class){one.devsbox.www.ui.users.edit.UserEVM()}
	ViewModelFactory.register(one.devsbox.www.ui.devices.detail.DeviceDVM::class){one.devsbox.www.ui.devices.detail.DeviceDVM()}
	ViewModelFactory.register(one.devsbox.www.ui.devices.ListingDevicesVM::class){one.devsbox.www.ui.devices.ListingDevicesVM()}
	ViewModelFactory.register(one.devsbox.www.ui.devices.edit.DeviceEVM::class){one.devsbox.www.ui.devices.edit.DeviceEVM()}
	ViewModelFactory.register(one.devsbox.www.ui.campaigns.detail.CampaignDVM::class){one.devsbox.www.ui.campaigns.detail.CampaignDVM()}
	ViewModelFactory.register(one.devsbox.www.ui.campaigns.ListingCampaignsVM::class){one.devsbox.www.ui.campaigns.ListingCampaignsVM()}
	ViewModelFactory.register(one.devsbox.www.ui.campaigns.edit.CampaignEVM::class){one.devsbox.www.ui.campaigns.edit.CampaignEVM()}
	ViewModelFactory.register(one.devsbox.www.ui.company.ListingCompanyVM::class){one.devsbox.www.ui.company.ListingCompanyVM()}
	ViewModelFactory.register(one.devsbox.www.ui.home.HomeVM::class){one.devsbox.www.ui.home.HomeVM()}
	ViewModelFactory.register(one.devsbox.www.ui.locations.detail.LocationDVM::class){one.devsbox.www.ui.locations.detail.LocationDVM()}
	ViewModelFactory.register(one.devsbox.www.ui.locations.ListingLocationVM::class){one.devsbox.www.ui.locations.ListingLocationVM()}
	ViewModelFactory.register(one.devsbox.www.ui.locations.edit.LocationEVM::class){one.devsbox.www.ui.locations.edit.LocationEVM()}
	ViewModelFactory.register(one.devsbox.www.ui.uploader.UploaderVM::class){one.devsbox.www.ui.uploader.UploaderVM()}
	ViewModelFactory.register(one.devsbox.www.ui.cmd.CmdVM::class){one.devsbox.www.ui.cmd.CmdVM()}
}

@ExtNavMarker
@Composable
private fun NavigationChild(
    startupNode: Node,
    startupArgs: ArgumentsNavigation?,
    animation: FiniteAnimationSpec<Float>,
    childKey:String,
    graph:Graph
) {

    val navigation = Navigation.rememberNavigationComposite(startupNode, startupArgs, childKey, graph, false)
    val currentNode = navigation.currentNode.collectAsState()

    Crossfade(targetState = currentNode.value, animationSpec = animation) {
        Surface(color = MaterialTheme.colorScheme.background) {
            CompositionLocalProvider(LocalNavigation provides navigation) {
                navNode(node = it)
            }
        }
    }
}

val Graph.Companion.HomeContent get()= Graph("HomeContent") 

@ExtNavMarker
@Composable
fun NavigationChildHomeContent(
    startupNode: Node,
    startupArgs: ArgumentsNavigation? = null,
    animation: FiniteAnimationSpec<Float> = tween()
) {
    val parentNavigation = LocalNavigation.current

    val childKey = remember {
        "${parentNavigation.navigationId}[${parentNavigation.nodeIdentifier}][$navChildKey.HomeContent]"
    }
    
    NavigationChild(startupNode, startupArgs, animation, childKey, Graph.HomeContent)
}